module.exports = __webpack_public_path__ + "static/fonts/shangshou.84cb2dd3.ttf";